import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import _ from "lodash";

import Form from "../../../general/Form/Form";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  truckNames: ""
};

class AddMultiplePlaceholderModal extends Component {
  state = initialState;

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    // format truck data
    let data = {
      ...this.props.truckData
    };
    // split truck names
    let truckNames = this.state.truckNames
      .split(";")
      .map((name) => name.trim())
      .filter((name) => name);

    let confirmationMessage = `You are about to create ${truckNames.length} placeholder trucks.\n\nProceed?`;
    if (window.confirm(confirmationMessage) == true) {
      // loop through each truck
      try {
        for (let name of truckNames) {
          if (name) {
            data.name = name.trim();
            // insert new placeholder truck
            let res = await axios.post(`${process.env.REACT_APP_API_HOST}/placeholder`, data, config);
            if (res.status === 200 && res.data.new_placeholder && res.data.new_placeholder[0].placeholder_id) {
              let placeholderId = res.data.new_placeholder[0].placeholder_id;
              // add waypoint gorups
              for (const [waypointGroupId, weightingData] of Object.entries(this.props.waypointsData)) {
                let res = await axios.put(
                  `${process.env.REACT_APP_API_HOST}/placeholder/${placeholderId}/waypoint_group/${waypointGroupId}`,
                  weightingData,
                  config
                );
                if (!(res.status === 200 && res.data.new_bridge && res.data.new_bridge[0].placeholder_waypoint_bridge_id)) {
                  throw "Couldn't link waypoint group with placeholder truck";
                }
              }
            } else {
              throw "Couldn't add placeholder truck";
            }
          }
        }
        alert("Added placeholder truck");
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    }
  };

  truckNameChangeHandler = (e) => {
    this.setState({
      truckNames: e.target.value
    });
  };

  toggle = () => {
    this.setState(initialState);
    this.props.toggleModal();
  };

  componentDidUpdate = () => {
    if (this.props.truckData && !this.state.truckNames) {
      this.setState({
        truckNames: this.props.truckData.name ? this.props.truckData.name : "Sample Placeholder Truck Name"
      });
    }
  };

  render() {
    const formStyle = {
      boxShadow: "none"
    };

    return (
      <Modal isOpen={this.props.show} toggle={this.toggle} size="lg">
        <ModalHeader toggle={this.toggle}>Add Multiple Placeholder Truck</ModalHeader>
        <ModalBody>
          <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
            <Row form className="mb-3">
              <Col>
                <FormGroup className="mb-2">
                  <Label>Placeholder Truck Names (Separated By Semicolons)</Label>
                  <Input
                    type="textarea"
                    rows="20"
                    value={this.state.truckNames ? this.state.truckNames : ""}
                    onChange={this.truckNameChangeHandler}
                    placeholder="Enter truck name..."
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onFormSubmitHandler}>
            Add
          </Button>
          <Button color="secondary" onClick={this.toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddMultiplePlaceholderModal;
